import { render, staticRenderFns } from "./BenchmarkColumn.vue?vue&type=template&id=579a7462&scoped=true&"
import script from "./BenchmarkColumn.vue?vue&type=script&lang=ts&"
export * from "./BenchmarkColumn.vue?vue&type=script&lang=ts&"
import style0 from "./BenchmarkColumn.vue?vue&type=style&index=0&id=579a7462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a7462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
